import { FlowPage } from 'src/lib/flow/FlowPage';
import { FlowQuestion } from 'src/lib/flow/FlowQuestion';
import { isAgent } from 'src/lib/flow/pageHelpers';

function isEnabled({ answers, inputContext: { channel } }) {
  return !isAgent(answers, channel);
}
const willingnessForTourPage: FlowPage = {
  slug: () => 'willingness-to-tour',
  isEnabled,
  title: () => 'For a potentially higher offer, are you open to buyers touring your home?',
  subtitle: () =>
    `On average, customers earned <span style="color: #007F5E; font-weight: 600">$40,000</span> more from selling to buyers in our network instead of selling to Opendoor.`,
  autoAdvance: () => true,
  questions: (): FlowQuestion[] => [
    {
      key: 'seller.willingness_for_tours',
      type: 'exclusives_radio_single_select',
      options: [
        {
          label: 'Yes, as many tours as needed to maximize sale price',
          value: 'yes any buyer for max price',
        },
        {
          label: 'Yes, limited tours for pre-qualified buyers, only',
          value: 'yes only pre-qualified buyers',
        },
        {
          label: 'No',
          value: 'no',
        },
      ],
    },
  ],
};

export default willingnessForTourPage;
